import connection from './connection.js'

const list = async function (
  page,
  keyword,
  status,
  start,
  end,
  userId,
  callback
) {
  const url = '/admin/order/list'
  let { error, data } = await connection.query(url, {
    page: page,
    keyword: keyword,
    status: status,
    start: start,
    end: end,
    user_id: userId,
  })
  if (callback) callback(error, data)
}

const updateLogistics = async function (params, callback) {
  const url = '/admin/order/update/logistics'
  let { error, data } = await connection.update(url, params)
  if (callback) callback(error, data)
}

const updateItemStatus = async function (params, callback) {
  const url = '/admin/order/update/item/status'
  let { error, data } = await connection.update(url, params)
  if (callback) callback(error, data)
}

const exportOrder = async function (params, callback) {
  const url = '/admin/order/export'
  let { error, data } = await connection.update(url, params)
  if (callback) callback(error, data)
}

const order_config = async function (params, callback) {
  const url = '/admin/order/import/order/detail/' + params
  let { error, data } = await connection.query(url)
  if (callback) callback(error, data)
}

const inventory_config = async function (params, callback) {
  const url = '/admin/order/import/inventory/detail/' + params
  let { error, data } = await connection.query(url)
  if (callback) callback(error, data)
}

const logistics_config = async function (params, callback) {
  const url = '/admin/order/import/logistics/detail/' + params
  let { error, data } = await connection.query(url)
  if (callback) callback(error, data)
}

const update_order_config = async function (params, id, callback) {
  const url = '/admin/order/import/order/update/' + id
  let { error, data } = await connection.update(url, params)
  if (callback) callback(error, data)
}

const update_logistic_config = async function (params, id, callback) {
  const url = '/admin/order/import/logistics/update/' + id
  let { error, data } = await connection.update(url, params)
  if (callback) callback(error, data)
}

const update_inventury_config = async function (params, id, callback) {
  const url = '/admin/order/import/inventory/update/' + id
  let { error, data } = await connection.update(url, params)
  if (callback) callback(error, data)
}

const orderMobaoPay = async function (params, callback) {
  const url = '/admin/order/pay'
  let { error, data } = await connection.update(url, params)
  if (callback) callback(error, data)
}

const orderStatusQuery = async function (params, callback) {
  const url = '/admin/order/pay/tran/query'
  let { error, data } = await connection.update(url, params)
  if (callback) callback(error, data)
}

const getOrderPushGoodsList = async function (id, callback) {
  const url = '/admin/order/import/order/goods/detail/' + id
  let { error, data } = await connection.query(url)
  if (callback) callback(error, data)
}

const getInventuryPushGoodsList = async function (id, callback) {
  const url = '/admin/order/import/inventory/goods/detail/' + id
  let { error, data } = await connection.query(url)
  if (callback) callback(error, data)
}

const editInventuryPushGoodsList = async function (id, params, callback) {
  const url = '/admin/order/import/inventory/goods/update/' + id
  let { error, data } = await connection.update(url, params)
  if (callback) callback(error, data)
}

const deletesRow = async function (params, callback) {
  const url = '/admin/order/delete'
  let { error, data } = await connection.update(url, params)
  if (callback) callback(error, data)
}

const editOrderPushGoodsList = async function (id, params, callback) {
  const url = '/admin/order/import/order/goods/update/' + id
  let { error, data } = await connection.update(url, params)
  if (callback) callback(error, data)
}

const fileUpload = async function (params, callback) {
  const url = '/admin/order/leadingIn'
  let { error, data } = await connection.update(url, params)
  if (callback) callback(error, data)
}

//刷新支付单报送接口
const refreshPayment = async function (params, callback) {
  const url = '/admin/order/pay/customs/status'
  let { error, data } = await connection.update(url, params)
  if (callback) callback(error, data)
}

export default {
  list: list,
  updateLogistics: updateLogistics,
  updateItemStatus: updateItemStatus,
  exportOrder: exportOrder,
  order_config: order_config,
  inventory_config: inventory_config,
  logistics_config: logistics_config,
  update_order_config: update_order_config,
  update_logistic_config: update_logistic_config,
  update_inventury_config: update_inventury_config,
  orderMobaoPay: orderMobaoPay,
  orderStatusQuery: orderStatusQuery,
  getOrderPushGoodsList: getOrderPushGoodsList,
  getInventuryPushGoodsList: getInventuryPushGoodsList,
  editInventuryPushGoodsList: editInventuryPushGoodsList,
  editOrderPushGoodsList: editOrderPushGoodsList,
  fileUpload: fileUpload,
  deletesRow: deletesRow,
  refreshPayment,
}
